module.exports = __webpack_public_path__ + "img/23.1fe46422.jpg";